import type { PerformanceTier } from "./performanceTiers";
import {
  combineRendererParams,
  defaultRendererParams,
  type RendererParams,
} from "./threejs/higharc/SSFXRendererParams";
import type { WebGLExtendedCapabilities } from "./WebGLExtendedCapabilities";

export interface RenderParamsServices {
  readonly capabilities: WebGLExtendedCapabilities;
  getPerformanceTierByScore(): Promise<PerformanceTier>;
}

/**
 * @param performanceTierOverride pins the tier instead of resolving one from the measured GPU
 * score, which varies by host and so is not reproducible across machines.
 */
export async function defaultRenderParamsForGPUTier(
  services: RenderParamsServices,
  performanceTierOverride?: PerformanceTier,
): Promise<RendererParams> {
  let renderParams = defaultRendererParams(services.capabilities);
  const performanceTier = performanceTierOverride ?? (await services.getPerformanceTierByScore());
  renderParams = combineRendererParams(renderParams, performanceTier.params);
  return renderParams;
}
